export default __webpack_public_path__ + "static/media/logo-1.47695455.png";